export class PrazoPagamentoApi {
    async list(filters = null) {
        try {
            const response = await axios.get(`/adm/prazos-pagamento/list`, {
                params: filters,
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching deadlines payment:', error);
            throw error;
        }
    }

    async show(id) {
        try {
            const response = await axios.get(`/adm/prazos-pagamento/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching deadline:', error);
            throw error;
        }
    }

    async store(data) {
        try {
            const response = await axios.post('/adm/prazos-pagamento', data);

            return response.data;
        } catch (error) {
            console.error('Error store deadline cd:', error);
            throw error;
        }
    }

    async pluck() {
        try {
            const response = await axios.get('/adm/prazos-pagamento/pluck');

            return response.data;
        } catch (error) {
            console.error('Error fetching pluck deadlines:', error);
            throw error;
        }
    }

    async regiao() {
         try {
            const response = await axios.get('/adm/prazos-pagamento/regiao', {
                params
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching deadlines per regions:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/PrazoPagamentoApi.js